var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRowing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.3,
    cy: 45,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2,
    cy: 45,
    rx: 9,
    ry: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,108.2c-1.9-1.3-4-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3 c-0.8-0.6-1.6-1.2-2.6-1.6L121.8,91H144v-2.7h-19.5L144,68.8V57.9H93.6c-2.5,0-4.7,1-6.3,2.6L59.5,88.3H47.2l20.1-20.1h3.2 c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1H16.3c-2.5,0-4.7,1-6.3,2.6l-10,10v18.3l0,0V91h40.6L23,108.6 c-0.2-0.1-0.4-0.3-0.6-0.4c-1.9-1.3-4-2.8-8-2.8s-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3v2.7c4,0,6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3c3.2,0,4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8v-2.7C140.8,110.6,139.3,109.5,137.6,108.2z M110.6,68.1h30.2l-12.9,12.9l-8.7-8.7c-1.1-1.1-2.3-1.7-3.8-1.7 c-1.5,0-2.7,0.6-3.8,1.7L95.7,88.3h-5.2L110.6,68.1z M120.5,88.3h-10.3l5.1-5.1L120.5,88.3z M92.8,108.2c-1.7,1.2-3.2,2.3-6.4,2.3 s-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8s-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3c-3.2,0-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8 s-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3c-1.4,0-2.5-0.2-3.4-0.5l19-19H118l-14.7,14.7c-0.7-0.1-1.6-0.2-2.5-0.2 C96.8,105.4,94.7,106.9,92.8,108.2z M13.2,88.3l20.1-20.1h30.2L50.5,81.1l-8.7-8.7c-1.1-1.1-2.3-1.7-3.8-1.7 c-1.5,0-2.7,0.6-3.8,1.7L18.4,88.3H13.2z M43.2,88.3H32.9l5.1-5.1L43.2,88.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowing);
export default __webpack_public_path__ + "static/media/rowing.f81f5bfb71e02828e8b089f9ba6e276b.svg";
export { ForwardRef as ReactComponent };